import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table, Message, Segment } from 'semantic-ui-react';
import styles from './ScheduledPayments.module.scss';
import AddScheduledPaymentModal from './AddScheduledPaymentModal';
import ScheduledPayment from './ScheduledPayment';

const ScheduledPayments = ({ actions, policies, wallets, scheduledPayments }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const [addOpen, setAddOpen] = useState(false);

	const load = useCallback(async () => {
		setLoading(true);
		try {
			setError(false);
			if (policies.length > 0) {
				await actions.getScheduledPayments(policies.map((p) => p.policyNumber));
			}

			await actions.getPaymentWallets(policies.length > 0 ? policies.map((p) => p.policyNumber) : []);
		} catch {
			setError(true);
		}
		setLoading(false);
	}, [actions, policies]);

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onAdd = useCallback(() => {
		setAddOpen(false);
		load();
	}, [load]);

	const onDelete = useCallback(() => {
		load();
	}, [load]);

	if (loading) return null;

	if (wallets.length === 0) {
		return (
			<Segment style={{ textAlign: 'center' }}>
				<h2>A wallet account is required before using scheduled payments</h2>
			</Segment>
		);
	}

	return (
		<div>
			{error && <Message error>Failed to load scheduled payments</Message>}

			{!error && (
				<React.Fragment>
					{policies.length > 0 && (
						<div className={styles.header}>
							<AddScheduledPaymentModal open={addOpen} onOpen={() => setAddOpen(true)} onClose={() => setAddOpen(false)} onAdd={onAdd} wallets={wallets} policies={policies} actions={actions} scheduledPayments={scheduledPayments} />
						</div>
					)}

					{scheduledPayments.length === 0 && (
						<Segment style={{ textAlign: 'center' }}>
							<h2>No Scheduled Payments</h2>
						</Segment>
					)}

					{scheduledPayments.length > 0 && (
						<Table>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>Policy/Account Number</Table.HeaderCell>
									<Table.HeaderCell>Scheduled Date</Table.HeaderCell>
									<Table.HeaderCell>Amount</Table.HeaderCell>
									<Table.HeaderCell></Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{scheduledPayments.map((sp, i) => {
									return <ScheduledPayment key={i} scheduledPayment={sp} onDelete={onDelete} actions={actions} />;
								})}
							</Table.Body>
						</Table>
					)}
				</React.Fragment>
			)}
		</div>
	);
};

ScheduledPayments.propTypes = {
	actions: PropTypes.object.isRequired,
	policies: PropTypes.array.isRequired,
	wallets: PropTypes.array.isRequired,
	scheduledPayments: PropTypes.array.isRequired,
};

export default ScheduledPayments;
